import { useIsStaff } from "@/lib/auth/auth.roles";

/**
 * useEvalSimulationEnabled gates the whole developer Simulate feature. Staff —
 * moderators, admins and super admins — get it; for everyone else nothing
 * mounts and there is no button.
 */
export function useEvalSimulationEnabled(): boolean {
  return useIsStaff();
}
